import styled from 'styled-components';

export const PageWrapper = styled.div`
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 40px;
    position: relative;
    height: 100%;

    @media (max-width: 768px) {
        padding: 0 20px;
    }
`;

export const ContentWrapper = styled.div`
    padding: 50px 0 0 0;

    @media (max-width: 768px) {
        padding: 30px 0 0 0;
    }
`;
